module.exports = __webpack_public_path__ + "static/media/Team 33 - Future Connect.bcca3232.jpg";